"use client";

import { Typography } from "@/components/ui/typography";
import type { UseCasePricingPlansProps } from "./types";
import { useCasePricingPlansCards } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { ServicesPricingPlans } from "@/components/screen/global-components/services";

const UseCasePricingPlans = ({
  content,
  className,
}: UseCasePricingPlansProps) => {
  const { pricingTitle, pricingDescription } = content;

  return (
    <section className={cn("section lg:bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4 md:gap-2 md:w-full md:max-w-[800px] md:mx-auto">
          {!!pricingTitle && (
            <Typography variant="heading4" className="text-center">
              <h2>{pricingTitle}</h2>
            </Typography>
          )}
          {!!pricingDescription && (
            <div className="flex justify-center text-gray-600">
              <Typography
                variant="subHeadingSm"
                className="text-center"
                asChild
              >
                <p>{pricingDescription}</p>
              </Typography>
            </div>
          )}
        </div>
        <ServicesPricingPlans
          className="mt-6 lg:mt-12"
          cards={useCasePricingPlansCards}
          cardClassName="lg:h-auto"
        />
      </div>
    </section>
  );
};

export default memo(UseCasePricingPlans);
